<template>
  <v-toolbar
        :color="toolbarColor"
        dark
        app
        dense
        clipped-left
      >
        <ToolbarHeader
          :useSide="true"
          :sideHandler="handleToolSide"
          :btnIcon="toolbarIcon"
          :btnHandler="handleToolHeadBtn"
          :title="title"
          :isLoading="isLoading"
        />
          <slot />
        <v-toolbar-items>
          <NotificationMenu/>
          <ProfileMenu />
        </v-toolbar-items>
      </v-toolbar>
</template>

<script>
import ProfileMenu from '@/components/ProfileMenu'
import NotificationMenu from '@/components/NotificationMenu'
import ToolbarHeader from '@/components/ToolbarHeader'

export default {
  components: {
    ProfileMenu,
    NotificationMenu,
    ToolbarHeader,
  },
  props: {
    title: String,
    handleToolSide: Function,
    handleToolHeadBtn: Function,
    toolbarIcon: String,
    toolbarColor: String,
    isLoading: Boolean,
  },
}
</script>

<style>
  .application .theme--dark.btn-toggle, .theme--dark .btn-toggle {
    background: transparent !important;
  }
  .btn-toggle--selected {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
  }
</style>
